<section class="em-dialog" aria-labelledby="confirmation-title">
  <header>
    <h2 class="em-dialog__title" id="confirmation-title" data-testid="confirmation-title">{{ data.title }}</h2>
  </header>
  <div class="em-dialog__body">
    @if (data.message) {
      <p class="em-dialog__text" data-testid="confirmation-message">{{ data.message }}</p>
    }
  </div>
  <footer class="em-dialog__actions">
    <button type="button" class="em-btn em-btn-ghost" (click)="close()">Cancel</button>
    <button type="button" class="em-btn" [class.em-btn-danger]="data.tone === 'danger'" [class.em-btn-primary]="data.tone !== 'danger'" (click)="close(true)">{{ data.confirmLabel || 'Confirm' }}</button>
  </footer>
</section>
